<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-data-table
                :headers="headers"
                :items="deliveries"
                dense
                item-key="id"
                :loading="loading"
                class="elevation-1"
                :footer-props="{
                          showFirstLastPage: true,
                          'items-per-page-options': [5, 10, 15, 30],
                          itemsPerPageText: 'Товаров на странице ',
                          showCurrentPage: false
                        }"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Доставка</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                            <v-btn @click="createDelivery">
                                    <span class="text-none">
                                        <v-icon>add</v-icon>Создать
                                    </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <!--<v-card-title>
                            <span class="headline">Редактирование</span>
                        </v-card-title>-->
                        <v-toolbar dark color="blue lighten-2">
                            <v-btn icon dark @click="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Редактировать </v-toolbar-title>

                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn dark text @click="save">
                                    <v-icon>save</v-icon>
                                    {{deliveryModel.id === null ? 'Создать' : 'Сохранить'}}
                                </v-btn>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text class="content">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-text-field v-model="deliveryModel.title"
                                                      label="Название"/>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-text-field v-model="deliveryModel.price"
                                                      label="Стоимость доставки"/>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-text-field v-model="deliveryModel.min_price"
                                                      label="Минимальный заказ для доставки"/>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-text-field v-model="deliveryModel.max_clients_in_time"
                                                      label="Максимальное количество людей записанных на одно время"/>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-select
                                                v-model="deliveryModel.type"
                                                label="Тип"
                                                :items="[ { value: 1, text: 'Самовывоз'}, { value: 2, text: 'Доставка' } ]"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-select
                                                v-model="deliveryModel.status"
                                                label="Статус"
                                                :items="[ { value: 1, text: 'Активно'}, { value: 2, text: 'Неактивно' } ]"
                                        />
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12" class="py-0">
                                        <v-textarea
                                                v-model="deliveryModel.description"
                                                label="Описание"
                                        />
                                    </v-col>
                                    <p>Спрашивать поля</p>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="name"
                                                inset
                                                label="Получатель" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="phone"
                                                inset
                                                label="Телефон" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="address"
                                                inset
                                                label="Адрес" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="date"
                                                inset
                                                label="Дата" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                        <v-btn
                                                @click="visibleDeliveryScheduleForm = true"
                                        >
                                            Настройки
                                        </v-btn>
<!--                                        todo подключить блок-->
                                        <DeliveryScheduleForm
                                                :visible="visibleDeliveryScheduleForm"
                                                @close="visibleDeliveryScheduleForm = false"
                                        ></DeliveryScheduleForm>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="time"
                                                inset
                                                label="Время" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="carNumber"
                                                inset
                                                label="Гос. номер машины" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="carModel"
                                                inset
                                                label="Марка машины" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" xs12 class="ma-0 py-1 px-4">
                                        <v-switch
                                                class="ma-0 pa-0"
                                                v-model="comment"
                                                inset
                                                label="Комментарий к заказу" color="primary"
                                                :false-value="0"
                                                :true-value="1"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" md12 class="py-0 px-7">
                                        <MailingGroupsPicker
                                                newLabel="Группа для уведомления о новых заказах"
                                                newFieldName="mailing_group_ids"
                                                :selectedMailingGroups="selectedMailingGroups"
                                                :mailingGroups="mailingGroups"
                                                :edit="true"
                                                @updateGroups="updateGroups"
                                        ></MailingGroupsPicker>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:item.type="{ item }">
                {{item.type == 1 ? 'Самовывоз' : 'Доставка'}}
            </template>
            <template v-slot:item.status="{ item }">
                {{item.status == 1 ? 'Активно' : 'Неактивно'}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    edit
                </v-icon>
                <v-icon
                        small
                        class="mr-2"
                        @click="deleteItem(item.id)"
                >
                    delete
                </v-icon>
            </template>
        </v-data-table>

        <v-snackbar
                v-model="paramsSnackbar.show"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="paramsSnackbar.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogConfirmation from '../../dialogs/DialogConfirmation'
import DeliveryScheduleForm from './DeliveryScheduleForm'
import MailingGroupsPicker from '../mailing/MailingGroupsPicker'
export default {
    name: 'CatalogTable',
    components: {
        DeliveryScheduleForm,
        DialogConfirmation,
        MailingGroupsPicker
    },
    data() {
        return {
            // deliveries: [],
            categories: [],
            offers: [],
            page: 1,
            options: { itemsPerPage: 15 },
            headers: [
                {
                    text: 'Название',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: 'Тип',
                    sortable: false,
                    value: 'type'
                },
                {
                    text: 'Цена',
                    sortable: false,
                    value: 'price'
                },
                {
                    text: 'Статус',
                    sortable: false,
                    value: 'status'
                },
                {
                    text: 'Минимальный заказ',
                    sortable: false,
                    value: 'min_price'
                },
                { text: ' ', sortable: false, value: 'action' }
            ],
            countItems: 0,
            lastPage: 1,
            loading: false,
            deliveryModel: {
                id: null,
                bot_id: null,
                title: '',
                type: 1,
                price: 0,
                min_price: 0,
                max_clients_in_time: 1,
                description: null,
                fields: 13,
                mailing_group_ids: []
            },
            deliveryModelDef: {
                id: null,
                bot_id: null,
                title: '',
                type: 1,
                price: 0,
                min_price: 0,
                max_clients_in_time: 1,
                description: null,
                fields: 13,
                mailing_group_ids: []
            },
            dialog: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!',
                show: false
            },
            dialogParams: {},
            visibleDeliveryScheduleForm: false,
            selectedMailingGroups: []
        }
    },
    computed: {
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            deliveries: 'cards/deliveries',
            mailingGroups: 'mailingGroups/mailingGroups'
        }),
        name: {
            get() {
                return this.deliveryModel.fields & (1 << 3) ? 1 : 0
            },
            set(value) {
                this.setBit(3, value)
            }
        },
        phone: {
            get() {
                return this.deliveryModel.fields & (1 << 2) ? 1 : 0
            },
            set(value) {
                this.setBit(2, value)
            }
        },
        address: {
            get() {
                return this.deliveryModel.fields & (1 << 1) ? 1 : 0
            },
            set(value) {
                this.setBit(1, value)
            }
        },
        date: {
            get() {
                return this.deliveryModel.fields & (1 << 6) ? 1 : 0
            },
            set(value) {
                this.setBit(6, value)
            }
        },
        time: {
            get() {
                return this.deliveryModel.fields & (1 << 0) ? 1 : 0
            },
            set(value) {
                this.setBit(0, value)
            }
        },
        carNumber: {
            get() {
                return this.deliveryModel.fields & (1 << 7) ? 1 : 0
            },
            set(value) {
                this.setBit(7, value)
            }
        },
        carModel: {
            get() {
                return this.deliveryModel.fields & (1 << 8) ? 1 : 0
            },
            set(value) {
                this.setBit(8, value)
            }
        },
        comment: {
            get() {
                return this.deliveryModel.fields & (1 << 4) ? 1 : 0
            },
            set(value) {
                this.setBit(4, value)
            }
        }
    },
    watch: {
        dialog(value) {
            if (!value) {
                this.deliveryModel = Object.assign({}, this.deliveryModelDef)
            }
        }
    },
    methods: {
        save() {
            this.$store.dispatch('cards/deliverySave', this.deliveryModel).then(response => {
                if (response.ok) {
                    this.deliveryModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Успешно сохранено!'
                }
                this.paramsSnackbar.show = true
            })
        },
        getDataFromApi () {
            this.loading = true
            this.$store.dispatch('cards/deliveriesAll', this.$route.params['pathMatch']).then(response => {
                this.lastPage = this.options.page
                this.countItems = response.response.count
                this.loading = false
            })
        },
        editItem(item) {
            this.deliveryModel = Object.assign({}, this.deliveries.find(delivery => delivery.id === +item.id))
            this.selectedMailingGroups = []
            for (let j = 0; j < this.mailingGroups.length; j++) {
                for (let i = 0; i < this.deliveryModel.mailing_group_ids.length; i++) {
                    if (this.deliveryModel.mailing_group_ids[i] === this.mailingGroups[j].id) {
                        this.selectedMailingGroups.push(this.mailingGroups[j])
                    }
                }
            }
            this.dialog = true
        },
        setBit(bit, value) {
            if (value) {
                this.deliveryModel.fields = this.deliveryModel.fields | (1 << bit)
            } else {
                this.deliveryModel.fields = this.deliveryModel.fields & (~(1 << bit))
            }
        },
        createDelivery() {
            this.deliveryModel = Object.assign({}, this.deliveryModelDef)
            this.dialog = true
        },
        async deleteItem(deliveryId) {
            this.$refs.confirm.open('Удаление доставки', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('cards/deliveryDelete', deliveryId).then(response => {
                            this.paramsSnackbar.color = 'error'
                            if (response.ok) {
                                this.paramsSnackbar.color = 'success'
                            }
                            this.paramsSnackbar.text = response.response.text
                            this.paramsSnackbar.show = true
                        })
                    }
                })
        },
        updateGroups(data) {
            let groupIds = []
            for (let i = 0; i < data.selectedMailingGroups.length; i++) {
                groupIds.push(data.selectedMailingGroups[i].id)
            }
            this.deliveryModel[data.field] = groupIds
            // this.saveButton()
        }
    },
    created() {
        this.getDataFromApi()
        this.deliveryModelDef.bot_id = +this.$route.params['pathMatch']
        this.$store.dispatch('mailingGroups/loadMailingGroups', this.$route.params['pathMatch'])
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
